module.exports = __webpack_public_path__ + "static/media/peak_rms.0ef5e8bb.png";